module.exports = {
  "dict": {
    "dict": "字典管理",
    "dictStatusHint": "字典状态",
    "statusNormal": "正常",
    "statusStop": "停用",
    "dictList": "字典列表",
    "dictName": "字典名称",
    "dictType": "字典类型",
    "status": "字典状态",
    "remark": "备注",
    "createTime": "创建时间",
    "dictData": "字典数据",
    "dataStatus": "数据状态",
    "dictLabel": "字典标签",
    "dictValue": "字典键值",
    "dictSort": "字典排序",
    "dictNameHint": '请输入字典名称',
    "dictTypeHint": '请输入字典类型',
    "remarkHint": '请输入备注',
    "deleteDictHint": "删除字典 {0} 将不可恢复，确定吗？",
    "deleteDictTyeHint": "删除字典标签 {0} 将不可恢复，确定吗？",
    "dictLabelHint": "请输入字典标签",
    "dictValueHint": "请输入字典键值",
    "dictSortHint": "请输入字典排序",
  },
};


// WEBPACK FOOTER //
// ./src/i18n/dict/zh-CN.js